import { Component, Inject, OnInit } from '@angular/core';
import { CampuscctvserviceService } from '../service/campuscctvservice.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-videostreaming',
  templateUrl: './videostreaming.component.html',
  styleUrls: ['./videostreaming.component.scss']
})
export class VideostreamingComponent implements OnInit { 
  cctvCreds: any;
  cctvFrameURL: any
  cctvURL: any;

  constructor(public campuscctvserviceservice: CampuscctvserviceService, @Inject(MAT_DIALOG_DATA) public data: any, private spinner: NgxSpinnerService, private domSanitizer: DomSanitizer) { }

  ngOnInit(): void {
    console.log(this.data);
    this.spinner.show();
    this.campuscctvserviceservice.getChannel(this.data.cctvDetId, this.data.channelsNo).subscribe((res) => {
      this.cctvCreds = res;
      console.log('cctvdetails', this.cctvCreds);
      // const URL = `https://cctvstream.scaits.net/CCTVIndex?cctvDetId=${this.cctvCreds[0].cctvDetId}&buildingId=${this.cctvCreds[0].buildingId}&ipAddress=${this.cctvCreds[0].ipAddress}&userName=${this.cctvCreds[0].userName}&pwd=${this.cctvCreds[0].password}&httpPortNo=${this.cctvCreds[0].rtspPortNo}&cctvChannelNo=${this.cctvCreds[0].channelsNo}&rtspPortNo=${this.cctvCreds[0].rtspPortNo}`
      const URL = `https://cctvstream.scaits.net/buildingCctvFrame?buildingId=${this.cctvCreds[0].buildingId}&dvrIPAddress=${this.cctvCreds[0].ipAddress}&userName=${this.cctvCreds[0].userName}&pwd=${this.cctvCreds[0].password}&portNo=${this.cctvCreds[0].rtspPortNo}&cctvChannelNo=${this.cctvCreds[0].channelsNo}`
  
      // ${this.cctvCreds[0].cctvStreamingBaseUrl}/
      this.cctvURL = this.domSanitizer.bypassSecurityTrustResourceUrl(URL);
      this.spinner.hide();
    });
  }

}
